import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import MasterLanding from "@/pages/MasterLanding";
import Funnel from "@/pages/Funnel";
import ProblemsSwipe from "@/pages/ProblemsSwipe";
import Trainings from "@/pages/Trainings";
import TrainingsJoin from "@/pages/TrainingsJoin";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import AdminTrainings from "@/pages/admin/AdminTrainings";
import AdminTeamUsers from "@/pages/admin/AdminTeamUsers";
import AdminChannelPartners from "@/pages/admin/AdminChannelPartners";
import AdminOnboardingPrograms from "@/pages/admin/AdminOnboardingPrograms";
import AdminProgress from "@/pages/admin/AdminProgress";
import AdminTemplates from "@/pages/admin/AdminTemplates";
import AdminApiDocs from "@/pages/admin/AdminApiDocs";
import TeamLogin from "@/pages/team/TeamLogin";
import TeamDashboard from "@/pages/team/TeamDashboard";
import Onboarding from "@/pages/Onboarding";
import RequireAdmin from "@/components/RequireAdmin";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<MasterLanding />} />
          <Route path="/diagnostics" element={<Funnel />} />
          <Route path="/problems" element={<ProblemsSwipe />} />
          <Route path="/trainings" element={<Trainings />} />
          <Route path="/trainings/join/:bookingId" element={<TrainingsJoin />} />
          <Route path="/trainings/:slug" element={<Trainings />} />
          <Route path="/admin" element={<AdminLogin />} />
          <Route
            path="/admin/dashboard"
            element={
              <RequireAdmin>
                <AdminDashboard />
              </RequireAdmin>
            }
          />
          <Route path="/admin/trainings" element={<RequireAdmin><AdminTrainings /></RequireAdmin>} />
          <Route path="/admin/team-users" element={<RequireAdmin><AdminTeamUsers /></RequireAdmin>} />
          <Route path="/admin/channel-partners" element={<RequireAdmin><AdminChannelPartners /></RequireAdmin>} />
          <Route path="/admin/onboarding-programs" element={<RequireAdmin><AdminOnboardingPrograms /></RequireAdmin>} />
          <Route path="/admin/progress" element={<RequireAdmin><AdminProgress /></RequireAdmin>} />
          <Route path="/admin/templates" element={<RequireAdmin><AdminTemplates /></RequireAdmin>} />
          <Route path="/admin/api-docs" element={<RequireAdmin><AdminApiDocs /></RequireAdmin>} />
          <Route path="/team/login" element={<TeamLogin />} />
          <Route path="/team" element={<TeamDashboard />} />
          <Route path="/onboard/:slug/:token" element={<Onboarding />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
